import { stVars as stVarsCE } from '../foundations/Colors.st.css';
import { stVars as stVarsRE } from '../foundations/Colors.responsive.st.css';
export const iconColorByEditor = {
    'B1-CE': stVarsCE['color-b1'],
    'B1-RE': stVarsRE['color-b1'],
    'link-CE': stVarsCE['color-b1'],
    'link-RE': stVarsRE['color-b1'],
    'B2-CE': stVarsCE['color-b2'],
    'B2-RE': stVarsRE['color-b2'],
    'B3-CE': stVarsCE['color-b3'],
    'B3-RE': stVarsRE['color-b3'],
    'B35-CE': stVarsCE['color-b35'],
    'B35-RE': stVarsRE['color-b35'],
    'B4-CE': stVarsCE['color-b4'],
    'B4-RE': stVarsRE['color-b4'],
    'B5-CE': stVarsCE['color-b5'],
    'B5-RE': stVarsRE['color-b5'],
    'R1-CE': stVarsCE['color-r1'],
    'R1-RE': stVarsRE['color-r1'],
    'alert-CE': stVarsCE['color-r1'],
    'alert-RE': stVarsRE['color-r1'],
    'R2-CE': stVarsCE['color-r2'],
    'R2-RE': stVarsRE['color-r2'],
    'R3-CE': stVarsCE['color-r3'],
    'R3-RE': stVarsRE['color-r3'],
    'R4-CE': stVarsCE['color-r4'],
    'R4-RE': stVarsRE['color-r4'],
    'P1-CE': stVarsCE['color-p1'],
    'P1-RE': stVarsRE['color-p1'],
    'premium-CE': stVarsCE['color-p1'],
    'premium-RE': stVarsRE['color-p1'],
    'P2-CE': stVarsCE['color-p2'],
    'P2-RE': stVarsRE['color-p2'],
    'P3-CE': stVarsCE['color-p3'],
    'P3-RE': stVarsRE['color-p3'],
    'P4-CE': stVarsCE['color-p4'],
    'P4-RE': stVarsRE['color-p4'],
    'Y1-CE': stVarsCE['color-y1'],
    'Y1-RE': stVarsRE['color-y1'],
    'warning-CE': stVarsCE['color-y1'],
    'warning-RE': stVarsRE['color-y1'],
    'Y2-CE': stVarsCE['color-y2'],
    'Y2-RE': stVarsRE['color-y2'],
    'Y3-CE': stVarsCE['color-y3'],
    'Y3-RE': stVarsRE['color-y3'],
    'Y4-CE': stVarsCE['color-y4'],
    'Y4-RE': stVarsRE['color-y4'],
    'O1-CE': stVarsCE['color-o1'],
    'O1-RE': stVarsRE['color-o1'],
    'urgent-CE': stVarsCE['color-o1'],
    'urgent-RE': stVarsRE['color-o1'],
    'O2-CE': stVarsCE['color-o2'],
    'O2-RE': stVarsRE['color-o2'],
    'O3-CE': stVarsCE['color-o3'],
    'O3-RE': stVarsRE['color-o3'],
    'O4-CE': stVarsCE['color-o4'],
    'O4-RE': stVarsRE['color-o4'],
    'G1-CE': stVarsCE['color-g1'],
    'G1-RE': stVarsRE['color-g1'],
    'success-CE': stVarsCE['color-g1'],
    'success-RE': stVarsRE['color-g1'],
    'G2-CE': stVarsCE['color-g2'],
    'G2-RE': stVarsRE['color-g2'],
    'G3-CE': stVarsCE['color-g3'],
    'G3-RE': stVarsRE['color-g3'],
    'G4-CE': stVarsCE['color-g4'],
    'G4-RE': stVarsRE['color-g4'],
    'D1-CE': stVarsCE['color-d1'],
    'D1-RE': stVarsRE['color-d1'],
    'standard-CE': stVarsCE['color-d1'],
    'standard-RE': stVarsRE['color-d1'],
    'D2-CE': stVarsCE['color-d2'],
    'D2-RE': stVarsRE['color-d2'],
    'secondary-CE': stVarsCE['color-d2'],
    'secondary-RE': stVarsRE['color-d2'],
    'D3-CE': stVarsCE['color-d3'],
    'D3-RE': stVarsRE['color-d3'],
    'D35-CE': stVarsCE['color-d35'],
    'D35-RE': stVarsRE['color-d35'],
    'placeholder-CE': stVarsCE['color-d35'],
    'placeholder-RE': stVarsRE['color-d35'],
    'D4-CE': stVarsCE['color-d4'],
    'D4-RE': stVarsRE['color-d4'],
    'secondary-light-CE': stVarsCE['color-d4'],
    'secondary-light-RE': stVarsRE['color-d4'],
    'D5-CE': stVarsCE['color-d5'],
    'D5-RE': stVarsRE['color-d5'],
    'D6-CE': stVarsCE['color-d6'],
    'D6-RE': stVarsRE['color-d6'],
    'standard-light-CE': stVarsCE['color-d6'],
    'standard-light-RE': stVarsRE['color-d6'],
    'dis1-CE': stVarsCE['color-dis1'],
    'dis1-RE': stVarsRE['color-x1'],
    'disabled-CE': stVarsCE['color-dis1'],
    'disabled-RE': stVarsRE['color-x1'],
    'dis2-CE': stVarsCE['color-dis2'],
    'dis2-RE': stVarsRE['color-x2'],
    'dis3-CE': stVarsCE['color-dis3'],
    'dis3-RE': stVarsRE['color-x3'],
    'dis4-CE': stVarsCE['color-dis4'],
    'dis4-RE': stVarsRE['color-x4'],
};
//# sourceMappingURL=iconsColors.js.map